import type { Permission } from '@riba/shared';
import { Result } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';
import { useAuthStore, useCan } from './auth.store';

/** Bounce to /login when there is no session. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

/**
 * Hide a page the principal lacks the permission for. The backend enforces the
 * same check — this only spares the user a 403.
 */
export function RequirePermission({
  permission,
  children,
}: {
  permission: Permission;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const allowed = useCan(permission);

  if (!allowed) {
    return <Result status="403" title="403" subTitle={t('common.error')} />;
  }
  return <>{children}</>;
}
